import './component.scss'
import { Application, Controller } from 'stimulus'

const maxSpTextLines = 4
const maxPcTextLines = 3

const app = Application.start()

app.register(
  'clamp-text',
  class extends Controller {
    static targets = ["bodyText"]

    connect() {
      // 初期状態を設定（PC: 3行、SP: 4行で省略）
      if (this.hasBodyTextTarget) {
        const device = this.element.getAttribute('data-device')
        const maxLines = device === 'sp' ? maxSpTextLines : maxPcTextLines
        this.bodyTextTarget.style.webkitLineClamp = maxLines
        this.bodyTextTarget.style.lineClamp = maxLines
      }
    }
  }
)
